module.exports = __webpack_public_path__ + "static/media/chrome_icon.a2275162.ico";